import { AcordeonFiltros } from "./AcordeonFiltros";
import { FormCheck } from "./FormCheck";
import { useState, useEffect } from 'react';
import styles from '../css/Filtros.module.scss';
import axios from "../axios";
import images from '../images';
import RangeSlider from "./RangeSlider";
import { Select } from "./Select";
import { ButtonDark } from "./ButtonDark";
import axiosRequest from "../axiosRequest";

export const Filtros = ({ buscarProductos, setCategorias, setBrands, orden, categoriasSeleccionadas = [], marcasSeleccionadas = [], minPriceSelect, maxPriceSelect, outlet }) => {

    const [value, setValue] = useState(false);
    const [categoriasSelect, setCategoriasSelect] = useState([]);
    const [brandsSelect, setBrandsSelect] = useState([]);
    const [listaCategorias, setListaCat] = useState([]);
    const [marcas, setMarcas] = useState([]);
    const [minPrice, setMinPrice] = useState(minPriceSelect ? minPriceSelect : 0);
    const [maxPrice, setMaxPrice] = useState(maxPriceSelect ? maxPriceSelect : 300);
    const [minRange, setMinRange] = useState(0);
    const [maxRange, setMaxRange] = useState(300);
    const [primerOrden, setPrimerOrden] = useState(true);
    const [ocultarPrecios, setOcultarPrecios] = useState(true);

    useEffect(() => {
        axiosRequest.get("/products/categories")
            .onResponse((response) => {
                setListaCat(response.data);
            })
        axiosRequest.get("/brands")
            .onResponse((response) => {
                setMarcas(response.data);
            })
        obtenerRangoPrecios();
    }, [])

    useEffect(() => {
        if (primerOrden)
            setPrimerOrden(false)
        else
            filtrar()
    }, [orden])

    const obtenerRangoPrecios = () => {

        axiosRequest.get("/products/precios" + (outlet ? '?on_sale=true' : ''))
            .onResponse((response) => {
                if (response.data.min_price !== null) {
                    setMinRange(Number(response.data.min_price))
                    var maxPriceAux
                    response.data.min_price === response.data.max_price ?
                        maxPriceAux = Number(response.data.max_price) + 1 : maxPriceAux = response.data.max_price
                    setMaxRange(Number(maxPriceAux))
                    if (!minPriceSelect)
                        setMinPrice(Number(response.data.min_price))
                    if (!maxPriceSelect)
                        setMaxPrice(Number(maxPriceAux))
                    setOcultarPrecios(false)
                }
                else
                    setOcultarPrecios(true)
            })
    }

    useEffect(() => {
        if (categoriasSeleccionadas) {
            const aux = categoriasSeleccionadas.map(id => {
                const item = listaCategorias.find(item => item.id === Number(id));
                return item ? { id: item.id, text: item.name } : undefined;
            }).filter(item => item !== undefined);
            setCategorias(aux);
            setCategoriasSelect(aux)
        }
    }, [listaCategorias])

    useEffect(() => {
        if (marcasSeleccionadas) {
            const aux = marcasSeleccionadas.map(id => {
                const item = marcas.find(item => item.name === id);
                return item ? { id: item.name, text: item.name } : undefined;
            }).filter(item => item !== undefined);
            setBrands(aux);
            setBrandsSelect(aux)
        }
    }, [marcas])

    const changeCatSelect = (category) => {
        setCategoriasSelect(prevValue => {
            if (prevValue.some(cat => cat.id === category.id)) {
                return prevValue.filter(cat => cat.id !== category.id);
            } else {
                return [...prevValue, category];
            }
        });
    };

    const changeBrandSelect = (brand) => {
        setBrandsSelect(prevValue => {
            if (prevValue.some(br => br.id === brand.id)) {
                return prevValue.filter(br => br.id !== brand.id);
            } else {
                return [...prevValue, brand];
            }
        });
        console.log(brandsSelect)
    };

    const generateFilterQuery = () => {
        let query = '';
        if (brandsSelect.length > 0) {
            const brandsIds = brandsSelect.map(brand => brand.id).join(',');
            query += (query ? '&' : '?') + `marcas=${brandsIds}`;
        }
        if (categoriasSelect.length > 0) {
            const categoryIds = categoriasSelect.map(cat => cat.id).join(',');
            query += (query ? '&' : '?') + `category=${categoryIds}`;
        }
        if (maxPrice !== maxRange)
            query += (query ? '&' : '?') + `max_price=${maxPrice}`;
        if (minRange !== minPrice)
            query += (query ? '&' : '?') + `min_price=${minPrice}`;


        return query;
    };

    function filtrar() {
        const query = generateFilterQuery();
        buscarProductos(query + (query ? '&' : '?') + `orderby=${orden.orderby}&order=${orden.order}`)
        window.history.pushState(null, '', (outlet ? '/outlet' : '/productos') + query + (orden.i !== 0 ? (query ? '&' : '?') + 'order=' + orden.i : ''));
        setCategorias(categoriasSelect)
        setBrands(brandsSelect)

    }
    const itemsAcordeon = [
        {
            titulo: 'Categorías', descripcion: listaCategorias.map(function (elem, i) {
                return <FormCheck id={elem.id} idCheck={'cat' + i} onChange={changeCatSelect} text={elem.name}
                    checked={categoriasSelect.some(cat => cat.id === elem.id)} />
            })
        },
        {
            titulo: 'Precio', descripcion: ocultarPrecios ? [] : <RangeSlider minValue={minPrice} setMinValue={setMinPrice} maxValue={maxPrice} setMaxValue={setMaxPrice}
                minRange={minRange} maxRange={maxRange} />
        },
        {
            titulo: 'Marcas', descripcion: marcas.map(function (elem, i) {
                return <FormCheck id={elem.name} idCheck={'brand' + i} checked={brandsSelect.some(brand => brand.id === elem.name)}
                    onChange={changeBrandSelect} text={elem.name} />
            })/* */
        }
    ];

    return (
        <>
            <div className={"border " + styles.filtros}>
                <div className="border-bottom fw-bold py-3">
                    <div className="row">
                        <div className="col">
                            Filtros
                        </div>
                        <div className="col-2 w-auto">
                            <img src={images.icons.filtros} />
                        </div>
                    </div>
                </div>
                <AcordeonFiltros items={itemsAcordeon} />
                <ButtonDark text={'Aplicar filtros'} funcion={filtrar} className={'w-100'} />
            </div>
        </>
    )

}